import { createAsyncAction } from "typesafe-actions";
import briefFormConstants from "./briefForm.constants";
import {
    MatSpecBriefingFormUpdateModel,
    BriefingFormAssetModel,
    BriefingFormModel,
    BriefingFormAdditionalAssetsModel,
} from "pages/BriefingForm/interfaces";

const {
    FETCH_BRIEF_FORM_REQUEST,
    FETCH_BRIEF_FORM_SUCCESS,
    FETCH_BRIEF_FORM_FAILED,
    UPLOAD_BRIEF_FORM_ASSET_REQUEST,
    UPLOAD_BRIEF_FORM_ASSET_SUCCESS,
    UPLOAD_BRIEF_FORM_ASSET_FAILED,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_REQUEST,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_SUCCESS,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_FAILED,
    REMOVE_BRIEF_FORM_ASSET_REQUEST,
    REMOVE_BRIEF_FORM_ASSET_SUCCESS,
    REMOVE_BRIEF_FORM_ASSET_FAILED,
    SUBMIT_BRIEF_FORM_REQUEST,
    SUBMIT_BRIEF_FORM_SUCCESS,
    SUBMIT_BRIEF_FORM_FAILED,
} = briefFormConstants;

export const fetchBriefForm = createAsyncAction(
    FETCH_BRIEF_FORM_REQUEST,
    FETCH_BRIEF_FORM_SUCCESS,
    FETCH_BRIEF_FORM_FAILED
)<{ materialSpecificationId: string }, BriefingFormModel, ErrorHandler>();

export const uploadBriefFormAsset = createAsyncAction(
    UPLOAD_BRIEF_FORM_ASSET_REQUEST,
    UPLOAD_BRIEF_FORM_ASSET_SUCCESS,
    UPLOAD_BRIEF_FORM_ASSET_FAILED
)<BriefingFormAssetModel, { fileName: string; id: number; index: number }, ErrorHandler>();

export const removeBriefFormAsset = createAsyncAction(
    REMOVE_BRIEF_FORM_ASSET_REQUEST,
    REMOVE_BRIEF_FORM_ASSET_SUCCESS,
    REMOVE_BRIEF_FORM_ASSET_FAILED
)<BriefingFormAssetModel, { id: number; removeFromArray?: boolean }, ErrorHandler>();

export const uploadBriefFormAdditionalAssets = createAsyncAction(
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_REQUEST,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_SUCCESS,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_FAILED
)<BriefingFormAdditionalAssetsModel, { fileName: string; id: number }[], ErrorHandler>();

export const submitBriefForm = createAsyncAction(
    SUBMIT_BRIEF_FORM_REQUEST,
    SUBMIT_BRIEF_FORM_SUCCESS,
    SUBMIT_BRIEF_FORM_FAILED
)<MatSpecBriefingFormUpdateModel, void, ErrorHandler>();
